import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { UserProvider } from './context/UserContext';
import { UserStatsProvider } from './context/UserStatsContext';
import { SubscriptionProvider } from './context/SubscriptionContext';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <UserProvider>
        <UserStatsProvider>
          <SubscriptionProvider>
            <App />
          </SubscriptionProvider>
        </UserStatsProvider>
      </UserProvider>
    </AuthProvider>
  </React.StrictMode>
);
